import { render } from "./DetailModalPopup.vue?vue&type=template&id=0bc8c261&scoped=true&ts=true"
import script from "./DetailModalPopup.vue?vue&type=script&lang=ts"
export * from "./DetailModalPopup.vue?vue&type=script&lang=ts"

import "./DetailModalPopup.vue?vue&type=style&index=0&id=0bc8c261&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8c261"]])

export default __exports__